export default __webpack_public_path__ + "c5706ec9cbe27a675d18b25106b3341e.svg";